var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon.isFaIcon)?_c('fa',{staticClass:"tw-mx-auto",class:[("text-" + _vm.textVariant)],attrs:{"icon":_vm.icon.icon}}):_c('CIcon',{class:[("text-" + _vm.textVariant)],attrs:{"icon":_vm.icon.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }